import EventEmitter from 'events';
import PricetypeSelector from './PricetypeSelector';

class ZonePricetypesCollection extends EventEmitter {
  /**
   * @param {HTMLElement} container
   */
  constructor(container) {
    super();

    /** @type {Map<string, PricetypeSelector>} */
    this.pricetypeSelectors = new Map();

    this.orderLevelFeeDisclaimer = container.querySelector('.tn-order-level-fee-disclaimer');

    const pricetypeContainers = Array.from(container.querySelectorAll('.tn-ticket-selector__pricetype-container'));

    pricetypeContainers.forEach((el) => {
      const { zoneId } = el.dataset;
      const pricetypeSelector = new PricetypeSelector(el, zoneId);

      pricetypeSelector.on('change', this.onChange);

      this.pricetypeSelectors.set(zoneId, pricetypeSelector);
    });
  }

  onChange = () => {
    this.emit('change');
  };

  /**
   * @param {string} zoneId
   */
  setCurrentZoneId(zoneId) {
    this.pricetypeSelectors.forEach((pricetypeSelector) => {
      if (pricetypeSelector.zoneId === zoneId) {
        pricetypeSelector.show();
      } else {
        pricetypeSelector.hide();
      }
    });

    if (this.orderLevelFeeDisclaimer) {
      this.orderLevelFeeDisclaimer.style.display = zoneId ? '' : 'none';
    }

    this.zoneId = zoneId;
  }

  /**
   * @private
   */
  getCurrentPricetypeSelector() {
    if (!this.zoneId) {
      return null;
    }

    return this.pricetypeSelectors.get(this.zoneId);
  }

  getData() {
    const pricetypeSelector = this.getCurrentPricetypeSelector();

    if (!pricetypeSelector) {
      return {};
    }

    const data = pricetypeSelector.getData();
    const isEditablePriceAvailable = data.some((el) => el.isUserPrice);

    return {
      isEditablePriceAvailable,
      isSelectionValid: pricetypeSelector.getIsSelectionValid(),
      totalQuantitySelected: pricetypeSelector.getTotalQuantitySelected(),
      allPricetypeQuantities: data,
      maxQuantity: pricetypeSelector.maxQuantity ?? Infinity,
    };
  }

  /**
   * @param {{pricetypeId: string, quantity: number}} pricetypeQuantities
   */
  restoreSelectedQuantities(pricetypeQuantities) {
    const pricetypeSelector = this.getCurrentPricetypeSelector();
    const pricetypeMax = pricetypeSelector.getMaxQuantity();
    let restoringTotal = 0;

    Object.entries(pricetypeQuantities).forEach(([pricetypeId, quantity]) => {
      if (pricetypeSelector.hasPricetype(pricetypeId)) {
        restoringTotal += quantity;
      }
    });

    if (restoringTotal <= pricetypeMax) {
      Object.entries(pricetypeQuantities).forEach(([pricetypeId, quantity]) => {
        if (pricetypeSelector.hasPricetype(pricetypeId)) {
          pricetypeSelector.setSelectedQuantityForPricetype(pricetypeId, quantity);
        }
      });

      pricetypeSelector.updateSelectsForMax();
    }
  }

  validateEditablePriceInputs() {
    const pricetypeSelector = this.getCurrentPricetypeSelector();
    if (pricetypeSelector) {
      pricetypeSelector.validateEditablePriceInputs();
    }
  }

  destroy() {
    this.removeAllListeners();

    this.pricetypeSelectors.forEach((pricetypeSelector) => {
      pricetypeSelector.destroy();
    });
  }
}

export default ZonePricetypesCollection;
